import { render, staticRenderFns } from "./CajaMensualList.vue?vue&type=template&id=0680ef69"
import script from "./CajaMensualList.vue?vue&type=script&lang=js"
export * from "./CajaMensualList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports